<template>
    <div class="my-tabs">
        <div
            v-for="(tab, index) in tabs"
            :key="tab.id"
            class="my-tabs-content"
            :class="{ 'is-active': isActive(tab) }"
            @click="handleTabClick(tab, index)"
        >
            <div class="content-info">
                <span>{{ tab.name }}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'myTabs',
    props: {
        tabs: {
            type: Array,
            default: () => []
        },
        /** 当前选中的 tab，支持 tab.id 或索引 index（Vue2 v-model 使用 value） */
        value: {
            type: [String, Number],
            default: ''
        }
    },
    methods: {
        isActive(tab) {
            const current = this.value;
            if ((current === '' || current == null) && this.tabs.length) {
                return this.tabs[0].id === tab.id;
            }
            return current === tab.id;
        },
        handleTabClick(tab, index) {
            this.$emit('input', tab.id);
            this.$emit('change', tab, index);
        }
    }
};
</script>

<style scoped lang="scss">
.my-tabs {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    width: 100%;
    min-height: 48px;
}

.my-tabs-content {
    width: 120px;
    height: 36px;
    background-color: #f7f7f7;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: height 0.2s, background-color 0.2s, color 0.2s;

    .content-info {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #464d5a;
        font-weight: 400;
        font-size: 14px;
        text-align: center;
    }

    /* 选中状态：高度 40px，背景 #297DEE，文字 #FFFFFF，底部三角形 */
    &.is-active {
        height: 40px;
        background-color: #297dee;
        position: relative;
        z-index: 999;
        .content-info {
            color: #ffffff;
        }

        /* 底部居中三角形 */
        &::after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: 0;
            z-index: 999;
            transform: translate(-50%, 100%);
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 8px solid #297dee;
            width: 0;
            height: 0;
        }
    }
}
</style>